import React from "react";
import PropTypes from "prop-types";
import { companyUrl } from "views_shared/app/javascript/utils/urls";

// Renders the "{job_title} at {org_name}" byline, with the org as a /companies/{slug} link
// when the story-idea index carries a slug. Falls back to plain text when it doesn't (e.g.
// before the public-pitches reindex that adds org_slug has run), so the card is safe either way.
function ExpertByline({ expert, orgLinkStyle }) {
  const jobTitle = expert?.job_title;
  const orgName = expert?.org_name;
  const orgSlug = expert?.org_slug;

  if (!jobTitle && !orgName) return null;

  let orgNode = orgName || null;
  if (orgName && orgSlug) {
    orgNode = (
      <a href={companyUrl({ slug: orgSlug, migrate_id: expert?.org_migrate_id })} style={orgLinkStyle}>
        {orgName}
      </a>
    );
  }

  return (
    <>
      {jobTitle}
      {jobTitle && orgName ? " at " : ""}
      {orgNode}
    </>
  );
}

ExpertByline.propTypes = {
  expert: PropTypes.shape({
    job_title: PropTypes.string,
    org_name: PropTypes.string,
    org_slug: PropTypes.string,
  }),
  orgLinkStyle: PropTypes.shape({}),
};

export default ExpertByline;
